import {createContext} from "react";

// Lets a page/panel opt every Hint underneath it into portal mode (renders the popup block into
// #modal_root, positioned via JS) without threading a `portal` prop through every field component
// and every call site. An explicit `portal` prop on a given <Hint> still overrides this.
export const HintPortalContext = createContext(false);
